import React from 'react';
import Box from './Box';

const Message = ({ children, ...rest }:any) => (
  <Box padding="16px" backgroundColor="greys.light" borderRadius="3px" textAlign="center" {...rest}>
    { children }
  </Box>
)

export default Message;
